<template>
  <div class="main">
    <div class="v-top-title">
      <span
        v-for="(item,index) in tabs"
        :id="index"
        :class="[index == activeId ? 'activeColor': '']"
        :key="item.id"
        @click="checkTab($event,item.id)"
      >{{item.isShow == true ? item.name : ''}}</span>
      <!-- <span>成片数据</span>
      <span>素材数据</span>-->
    </div>
    <div>
      <videoList :parentList="videoList"></videoList>
      <div class="tar" style="background:#fff;padding:20px 30px;">
        <el-pagination
          @current-change="handleCurrentChange"
          :current-page.sync="page"
          background
          layout="prev, pager, next, jumper"
          :total="total"
          v-if="total != 0"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import videoList from "../videolist/videolist";

export default {
  components: {
    videoList
  },
  data: function() {
    return {
      activeId: 0,
      tabs: [
        /* {
          id: 0,
          name: "全部数据",
          isShow: false
        }, */
        {
          id: 0,
          name: "京昆组",
          isShow: false
        },
        {
          id: 1,
          name: "地方戏组",
          isShow: false
        },
        {
          id: 2,
          name: "集体节目",
          isShow: false
        }
      ],
      total: 0, // 分页总数
      limit: 20,
      page: 1,
      videoList: [
        {
          id: 0,
          imgUrl: require("../../../assets/img/06.png")
        },
        {
          id: 1,
          imgUrl: require("../../../assets/img/06.png")
        },
        {
          id: 2,
          imgUrl: require("../../../assets/img/06.png")
        },
        {
          id: 3,
          imgUrl: require("../../../assets/img/06.png")
        },
        {
          id: 4,
          imgUrl: require("../../../assets/img/06.png")
        },
        {
          id: 5,
          imgUrl: require("../../../assets/img/06.png")
        }
      ],
      flowerCategory: "",
      roleId: ""
    };
  },
  mounted() {
  /*   this.roleId = this.$store.state.userInfo.roleid;
    this.getIsShow(this.roleId,'getFlowerList'); */
  },
  methods: {
    getIsShow(roleid) {
      // console.log(roleid)
      for (var i = 0; i < this.tabs.length; i++) {
        if (roleid == 6) {
          this.tabs[i].isShow = true;
          this.flowerCategory = "京昆组";
        } else if (roleid == 7) {
          this.tabs[1].isShow = true;
          this.tabs[2].isShow = true;

          // 地方戏组
          this.flowerCategory = "地方戏组";
          this.activeId = 1;
        } else if (roleid == 8) {
          this.tabs[0].isShow = true;
          this.tabs[2].isShow = true;
          // 京昆组
          this.flowerCategory = "京昆组";
        } else if (roleid == 9) {
          this.tabs[2].isShow = true;
          // 集体节目
          this.flowerCategory = "集体节目";
          this.activeId = 2;

        }
      }
      

      // console.log(this.tabs);
    },
    getFlowerList: async function() {
      // console.log(cate)
      // 京昆组或地方戏组
      var res = await this.$http.get(
        `/v1/videoInfo/getPrizeList?page=${this.page}&category=${this.flowerCategory}&limit=10`
      );
      var { code, data, message, total } = res.data;
      if (code == 0) {
        this.videoList =JSON.parse(JSON.stringify(data));
        console.log(this.videoList,'333333333333333')
        this.total = total;
        document.querySelector('.v-top-title').scrollIntoView(true)

      } else {
        this.$message.error(message);
      }
    },
    handleCurrentChange: function(val) {
      this.page = val;
      this.getFlowerList();
      window.localStorage.setItem('currentpage',val)
      //   document.querySelector('#nav_bread').scrollIntoView(true)
    },
    // ---选择类别
    checkTab: function(e, id) {
      this.page = 1;
      this.activeId = id;
      window.localStorage.setItem('tabactiveid',this.activeId)
     /*  if (id == 0) {
        this.flowerCategory = "";
        this.getFlowerList('');

        return false;
      } */
      if (id == 0) {
        // 京昆组
        this.flowerCategory = "京昆组";
        this.getFlowerList();
      window.localStorage.setItem('tabname',this.flowerCategory)

        return false;
      }
      if (id == 1) {
        // 地方戏组
        this.flowerCategory = "地方戏组";
        this.getFlowerList();
      window.localStorage.setItem('tabname',this.flowerCategory)

        return false;
      }
      if (id == 2) {
        // 地方戏组
        this.flowerCategory = "集体节目";
        this.getFlowerList();
      window.localStorage.setItem('tabname',this.flowerCategory)

        return false;
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if (
        vm.$store.state.userInfo.roleid != "6" &&
        vm.$store.state.userInfo.roleid != "7" &&
        vm.$store.state.userInfo.roleid != "8" &&
        vm.$store.state.userInfo.roleid != "9"
      ) {
        vm.$router.push({ path: "/home" });
      }
    
      // console.log(from)
      if(from.path == '/videodetail2'){
        console.log('fromlist111111111111111')
        vm.roleId = vm.$store.state.userInfo.roleid;

        vm.getIsShow(vm.roleId); 
        vm.page = window.localStorage.getItem('currentpage')
        vm.flowerCategory = window.localStorage.getItem('tabname')
        vm.activeId =  window.localStorage.getItem('tabactiveid')
           
        vm.getFlowerList()
      
      }else{
        window.localStorage.setItem('currentpage',1)
        vm.roleId = vm.$store.state.userInfo.roleid;
        vm.getIsShow(vm.roleId);
        vm.getFlowerList()

      }
    });
  }
};
</script>
<style lang="scss">
// 顶部
.activeColor {
  border-bottom: 2px solid #00aaff;
  color: #00aaff !important;
}
.v-top-title {
  width: 1200px;
  margin: 0 auto;
  font-size: 20px;
  font-weight: bold;
  // margin-bottom: 10px;
  background-color: #fff;
  padding: 0px 20px;
  border-bottom: 1px solid #e9e9e9;
  span {
    display: inline-block;
    // height: 30px;
    color: #979797;
    margin-right: 60px;
    padding: 30px 0 10px 0px;
    // &:first-child{
    //   border-bottom: 2px solid #00aaff;
    //   color: #00aaff;
    // }
    &:hover {
      border-bottom: 2px solid #00aaff;
      color: #00aaff;
      cursor: pointer;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/home/searchpages/flowpage.vue